import { Drawer, type DrawerProps } from 'antd'
import { type ReactNode } from 'react'

import { Z_INDEX_HIGH } from '@/const/z-index'

import { UrlParam, useUrlParams } from '@/lib/url/url-param.hook'

import '@/pages/company-drawer/antd-drawer.less'

type UrlParamDrawerProps = {
  urlParam: UrlParam
  width: string | number
  /** When set, overrides the default `removeParam(urlParam)` close behavior. */
  onClose?: () => void
  afterOpenChange?: (open: boolean) => void
  getContainer?: DrawerProps['getContainer']
  /** Applied to the AntD drawer body, for children that need it to be a flex container. */
  bodyClassName?: string
  children: ReactNode
}

/**
 * Shared AntD drawer shell driven by a URL param. Content layout belongs in
 * `DrawerLayout` inside children — this only owns open/close + chrome.
 */
export const UrlParamDrawer = ({
  urlParam,
  width,
  onClose,
  afterOpenChange,
  getContainer,
  bodyClassName,
  children,
}: UrlParamDrawerProps) => {
  const { urlParams, removeParam } = useUrlParams()
  const paramValue = urlParams[urlParam]
  const open = !!paramValue

  return (
    <Drawer
      zIndex={Z_INDEX_HIGH}
      width={width}
      closeIcon={false}
      open={open}
      onClose={onClose ?? (() => removeParam(urlParam))}
      afterOpenChange={afterOpenChange}
      getContainer={getContainer}
      classNames={{ body: bodyClassName }}
    >
      {open ? children : null}
    </Drawer>
  )
}
